export function workoutFrequencyToWeeklyGoal(workoutFrequency: string | null | undefined): number | null {
  if (!workoutFrequency) return null;

  switch (workoutFrequency) {
    case "2-times":
      return 2;
    case "3-times":
      return 3;
    case "4-times":
      return 4;
    case "5-plus":
      return 5;
    default:
      return null;
  }
}


